export default [
    {
        title: "Dashboard",
        route: "dashboard"
    },
    // {
    //     title: "Impostazioni",
    //     route: "settings"
    // },
    // {
    //     title: "Visualizza disiscrizioni",
    //     route: "unsubscriptions"
    // },
    // {
    //     title: "Coda email",
    //     children: [
    //         {
    //             title: "Visualizza coda",
    //             route: "queue"
    //         },
    //         {
    //             title: "Accoda un email",
    //             route: "queue.enqueue"
    //         }
    //     ]
    // },
    {
        title: "Template email",
        children: [
            {
                title: "Visualizza template",
                route: "templates"
            },
            {
                title: "Crea un template",
                route: "templates.create"
            }
        ]
    },
    // {
    //     title: "Campagne email",
    //     children: [
    //         {
    //             title: "Visualizza campagne",
    //             route: "campaigns",
    //         },
    //         {
    //             title: "Crea una campagna",
    //             route: "campaigns.create"
    //         }
    //     ]
    // }
];
